var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconClass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5686_21719)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3821 0V4.99974H2V15.0024H21.3821V20.0016H22V0.00156623L21.3821 0ZM2.61792 14.3493V5.64964H21.3821V14.3514L2.61792 14.3493Z",
    fill: "#868E96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.02846 8.95955C8.0261 8.6798 8.03756 8.40012 8.06282 8.12163C7.85928 8.14205 7.65475 8.14905 7.45038 8.14258H6.823C6.62485 8.14974 6.4265 8.13765 6.23047 8.10645V9.06743C6.43045 9.04295 6.63162 9.03088 6.83295 9.03129H7.03213V11.6807C7.03571 11.9431 7.02256 12.2056 6.99279 12.4662H8.06979C8.0404 12.2056 8.02725 11.9431 8.03045 11.6807L8.02846 8.95955Z",
    fill: "#868E96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4214 9.92924C10.261 9.93112 10.1008 9.91885 9.94238 9.89258V10.8798C10.1009 10.8541 10.2611 10.842 10.4214 10.8436H11.3993C11.5598 10.8419 11.7202 10.854 11.8788 10.8798V9.89258C11.7202 9.91879 11.5598 9.93106 11.3993 9.92924H10.4214Z",
    fill: "#868E96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.169 11.3343C16.0939 11.4394 15.9959 11.5239 15.8832 11.5809C15.7706 11.6379 15.6466 11.6655 15.5217 11.6616C14.9092 11.6616 14.5438 11.1473 14.5438 10.3C14.5438 9.44271 14.8923 8.94363 15.4973 8.94363C15.6892 8.93166 15.878 8.99878 16.0237 9.13076C16.1693 9.26275 16.2604 9.44922 16.2775 9.65062L17.2953 9.44115C17.2506 9.18097 17.1454 8.93646 16.9891 8.72944C16.8165 8.50064 16.5939 8.31921 16.3402 8.20064C16.0865 8.08208 15.8092 8.02992 15.5321 8.04864C15.0107 8.02744 14.502 8.22138 14.1146 8.58909C13.9116 8.8177 13.7542 9.08671 13.6516 9.38027C13.549 9.67383 13.5032 9.98601 13.5171 10.2984C13.4918 10.9197 13.6973 11.5269 14.0902 11.9916C14.2849 12.1851 14.5147 12.3354 14.7659 12.4337C15.017 12.5319 15.2844 12.576 15.5521 12.5634C15.8078 12.58 16.064 12.5379 16.3028 12.4402C16.5416 12.3424 16.7574 12.1913 16.9353 11.9973C17.1507 11.7248 17.2924 11.3963 17.3456 11.0463L16.3179 10.885C16.3079 11.0462 16.2564 11.2015 16.169 11.3343Z",
    fill: "#868E96"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5686_21719"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClass);
export default __webpack_public_path__ + "static/media/icon_class.70882151.svg";
export { ForwardRef as ReactComponent };